import { useEffect, useState, useRef } from "react"
import axios from "axios";
import { useTranslation } from "react-i18next";
import { FaSpinner } from "react-icons/fa";

import Divulgar from "../../src/assets/img/vagas/divulgar.png";
import Atualizar from "../../src/assets/img/vagas/atualizar.png";
import Identificar from "../../src/assets/img/vagas/identificar.png";
import MeninaApontando from "../../src/assets/img/vagas/girl-pointing.png";

const GoogleAd = ({ ad }) => {
  const containerRef = useRef();

  useEffect(() => {
    if (ad?.html && containerRef.current) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = ad.html;

      Array.from(tempDiv.children).forEach(child => {
        if (child.tagName.toLowerCase() !== 'script') {
          containerRef.current.appendChild(child);
        }
      });

      Array.from(tempDiv.getElementsByTagName('script')).forEach(script => {
        const newScript = document.createElement('script');
        if (script.src) {
          newScript.src = script.src;
          newScript.async = true;
        } else {
          newScript.text = script.innerHTML;
        }
        newScript.crossOrigin = "anonymous";
        containerRef.current.appendChild(newScript);
      });
    }
  }, [ad]);

  return <div ref={containerRef} className="google" style={{ minHeight: '150px', padding: '10px' }} />;
};

const Vagas = () => {
	const { t } = useTranslation('jobs');

	const [filters, setFilters] = useState({ pais: '', area: '', tipo_contrato: '' });
	const [vagas, setVagas] = useState([]);
	const [loading, setLoading] = useState(false);
	const [erro, setErro] = useState(null);
	const [vagaSelecionada, setVagaSelecionada] = useState(null);
	const isLocalhost = window.location.hostname === 'localhost';

	async function getJobs() {
		setLoading(true);
		setErro(null);
		try {
			let URL = 'https://flow-bqd4bfe8f4bjhua5.brazilsouth-01.azurewebsites.net/api/rh/vagas';
			const params = new URLSearchParams(filters);
			const apiUrl = `${URL}?${params.toString()}`;
			const response = await axios.get(apiUrl);
			setVagas(response.data);
		} catch (error) {
			console.error('❌ Erro ao buscar vagas:', error);
			setErro('Erro ao buscar vagas');
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		getJobs();
	}, []);

	useEffect(() => {
		if (!isLocalhost) {
			const script = document.createElement('script');
			script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3329971741558817";
			script.async = true;
			script.crossOrigin = "anonymous";
			document.body.appendChild(script);

			script.onload = () => {
				console.log('✅ Script adsbygoogle.js carregado!');
			};

			return () => {
				document.body.removeChild(script);
			};
		}
	}, [isLocalhost]);

	const selecionarVaga = (vaga) => setVagaSelecionada(vaga);
	const fecharDetalhes = () => setVagaSelecionada(null);
	const handleChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });
	const handleSubmit = (e) => { e.preventDefault(); getJobs(); };

	return (
		<>
			<div className="content-wrapper">
				{/* Título e seção explicativa */}
				<section className="title-section">
					<div className="container">
						<h2 className="title">{t('title')}</h2>
						<p className="subtitle">{t("subtitle")}</p>
					</div>
				</section>
				<section className="how-it-works-section">
					<div className="container">
						<div className="text-content">
							{/* Imagens explicativas */}
							<div><img src={Identificar} alt="" /><p className="title">{t('text1')}</p></div>
							<div><img src={Atualizar} alt="" /><p className="subtitle">{t('text2')}</p></div>
							<div><img src={Divulgar} alt="" /><p className="subtitle">{t('text3')}</p></div>
						</div>
						{/* Filtros e listagem */}
						<div className="jobs-container">
							<form className="filters" onSubmit={handleSubmit}>
								<div className="jobs-filters">
									<div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
										<label htmlFor="pais">{t("filters.localization")}</label>
										<select name="pais" value={filters.localization} onChange={handleChange}>
											<option value="">Todos</option>
											<option value="portugal">Portugal</option>
											<option value="brasil">Brasil</option>
										</select>
									</div>
									<div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
										<label htmlFor="area">{t("filters.area")}</label>
										<select name="area" value={filters.area} onChange={handleChange}>
											<option value="">Todos</option>
											<option value="frontend">Frontend</option>
											<option value="backend">Backend</option>
											<option value="bi">Business Intelligence</option>
											<option value="rh">Recursos Humanos</option>
										</select>
									</div>
									<div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
										<label htmlFor="tipo_contrato">{t("filters.type")}</label>
										<select name="tipo_contrato" value={filters.type} onChange={handleChange}>
											<option value="">Todos</option>
											<option value="CLT">CLT</option>
											<option value="PJ">PJ</option>
											<option value="Estágio">Estágio</option>
										</select>
									</div>
									<button type="submit">{t("filters.button")}</button>
								</div>
							</form>
							<div className="grid-container">
								{loading ? (
									<FaSpinner size={24} className="loadingIcon" style={{ margin: 'auto' }} />
								) : (
									vagas.map((item, index) => {
										if (item.tipo === 'google') {
											return isLocalhost ? (
												<div key={`ad-${index}`} className="google" style={{ minHeight: '150px', backgroundColor: '#eee', padding: '20px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', fontStyle: 'italic', color: '#666', textAlign: 'center' }}>
												📢 [Simulação de Anúncio Google]
											</div>
											) : (
												<GoogleAd ad={item} key={`ad-${index}`} />
											);
										}

										return (
											<div key={item.id} onClick={() => selecionarVaga(item)} className="vaga">
												<div className="text">
													<h3>{item.titulo}</h3>
													<p><strong>{t('cards.city')}:</strong> {item.cidade}</p>
													<p><strong>{t('cards.country')}:</strong> {item.pais}</p>
													<p><strong>{t('cards.contract_type')}:</strong> {item.tipo_contrato}</p>
												</div>
											</div>
										);
									})
								)}
							</div>
						</div>
					</div>
				</section>
				<section className="talents-section">
					<div className="container">
						<h2>{t("talents.title")}</h2>
						<p>{t("talents.subtitle")}</p>
						<div style={{ display: "flex" }}>
							<a href="/cadastro" className="botao-candidatar">{t("talents.button")}</a>
							<img src={MeninaApontando} alt="" />
						</div>
					</div>
				</section>
			</div>

			{vagaSelecionada && (
				<div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: "auto", zIndex: 1000 }} className="vaga">
					<div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '10px', maxWidth: '600px', width: '90%', maxHeight: '80%', overflowY: 'auto', position: 'relative' }}>
						<button onClick={fecharDetalhes} style={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', border: "none" }}>❌</button>
						<h3>{vagaSelecionada.titulo}</h3>
						<p><strong>{t('cards.summary')}:</strong> {vagaSelecionada.resumo}</p>
						<p><strong>{t('cards.city')}:</strong> {vagaSelecionada.cidade}</p>
						<p><strong>{t('cards.country')}:</strong> {vagaSelecionada.pais}</p>
						<p><strong>{t('cards.contract_type')}:</strong> {vagaSelecionada.tipo_contrato}</p>
						<p><strong>{t('cards.salary_range')}:</strong> {vagaSelecionada.faixa_salarial}</p>
						<p><strong>{t('cards.benefits')}:</strong> {vagaSelecionada.beneficios}</p>
						<p><strong>{t('cards.responsibilities')}:</strong> {vagaSelecionada.responsabilidades}</p>
						<p><strong>{t('cards.required_qualifications')}:</strong> {vagaSelecionada.requisitos_obrigatorios}</p>
						<p><strong>{t('cards.preferred_qualifications')}:</strong> {vagaSelecionada.requisitos_desejaveis}</p>
						<p><strong>{t('cards.languages')}:</strong> {vagaSelecionada.idiomas}</p>
						<a href={vagaSelecionada.link_candidatura} className="botao-candidatar" target="_blank" rel="noopener noreferrer">Candidatar-se</a>
					</div>
				</div>
			)}
		</>
	);
};

export default Vagas;